import React from 'react';
import cn from 'classnames';

import styles from './Table.module.sass';
import { Loader } from 'components/Loader';
import Row from './Row';

// data
import { IUserEvenTicketListItem } from '@types';

interface TableProps {
  className?: string;
  isRequestLoading: boolean;
  tickets: IUserEvenTicketListItem[] | undefined;
}

const Table: React.FC<TableProps> = ({ className, tickets, isRequestLoading }) => {
  return (
    <>
      {isRequestLoading && <Loader />}
      <div className={cn(styles.wrapper, className)}>
        <div className={cn(styles.table)}>
          <div className={cn(styles.row, styles.active)}>
            <div className={styles.col}></div>
            <div className={styles.col}></div>
            <div className={styles.col}>სახელი</div>
            <div className={styles.col}>თარიღი</div>
            <div className={styles.col}>ბილეთების რაოდენობა</div>
            <div className={styles.col}>ქულა</div>
            <div className={styles.col}>QR კოდის ბმულები</div>
          </div>

          {!isRequestLoading && tickets?.map(ticket => <Row item={ticket} key={ticket.event.id} />)}
        </div>
      </div>
    </>
  );
};

export default Table;
